import React, { useState } from "react";
import LazyImage from "../LazyImage/LazyImage";
import "./ReusableSlider.scss";

export default function ReusableSlider({ title, description, slides }) {
  const [isCurrent, setIsCurrent] = useState(0);
  const nextSlide = () => setIsCurrent((isCurrent + 1) % slides.length);
  const prevSlide = () =>
    setIsCurrent((isCurrent - 1 + slides.length) % slides.length);
  const goToSlide = (index) => setIsCurrent(index);
  return (
    <div className="reusable-slider">
      {/*----- Slider Header -----*/}
      <div className="reusable-slider__header">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>

      {/*----- Slider -----*/}
      <div className="reusable-slider__container">
        <button className="arrow left" onClick={prevSlide}>
          &#10094;
        </button>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === isCurrent ? "active" : ""}`}
          >
            <LazyImage src={slide} alt={`Slide ${index}`} />
          </div>
        ))}
        <button className="arrow right" onClick={nextSlide}>
          &#10095;
        </button>
      </div>

      {/*----- Slider Indicator -----*/}
      <div className="reusable-slider__indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === isCurrent ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          ></button>
        ))}
      </div>
    </div>
  );
}
